// removed by extract-text-webpack-plugin
module.exports = {"tabActiveButton":"_2yj-J","tabInactiveButton":"_26Go8","labelTypography":"_1_hZL","smallLinkTypography":"w79-Q","base":"_2pQ82","titleTypography":"_2LEe0","cardTitleTypography":"_2QWUm","truncate":"_1YZ1I","noTopPadding":"_1KIWJ","noBottomPadding":"_1uccm","noPadding":"_-4xNJ","joel":"_36HT_","xSmall":"_1Xa87","small":"_2P6pH","medium":"_3rCIk","large":"_3CYQ9","mega":"_1hrcB","h1":"_1bRGo","h2":"RlsTO","h3":"tAVcm","h4":"_2rwcW","h5":"_2bmps","h6":"_1Z5F-","h7":"_2zIO2","h8":"_297yA"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Heading/Heading.scss
// module id = 1491
// module chunks = 0